/**
 * Calculate the total price for an order.
 * Shared across OrderReview, PaymentScreen, and OrderConfirmation.
 */
export const calculateTotal = (order) => {
  let total = 0;

  if (order.product) total += order.product.price;

  if (order.burger) {
    total += 1.50;
    if (order.burgerSauce?.price) {
      total += order.burgerSauce.price;
    }
  }

  if (order.extraSides?.length > 0) {
    order.extraSides.forEach(extra => {
      total += extra.price * (extra.quantity || 1);
    });
  }

  return total;
};
